import 'core-js/stable';
import 'regenerator-runtime/runtime';
import axios from 'axios';
import React from 'react';
import ReactDom from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import * as translations from '../__translations__';
import { MainScene } from './__scenes__/main';
import SubScene from './__scenes__/sub';
import NotiTimeSetting from './__scenes__/notiTime/sub';
import NotFoundScene from '~/__scenes__/not-found';
import UnknownScene from '~/__scenes__/unknown';
import { PageProvider, MenuItemId } from '~/__modules__/page';
import { getLanguage } from '~/__modules__/browser';
import { initI18n } from '~/__modules__/i18n';
import * as fallbackTranslations from '~/__translations__';
import { ToastProvider } from '~/__modules__/toast';
import { DialogProvider } from '~/__modules__/dialog';
import { injectIntlAndTimezonePolyfill } from '~/__modules__/polyfill';
import { ServiceURL } from '~/__modules__/env';
import { getTimeZones } from '~/notify/settings/__modules__/utils/moment';
import { sendNeloLog } from '~/notify/settings/__modules__/utils/sendlog';
import { AppErrorBoundary } from '~/notify/settings/__modules__/component';

const language = getLanguage();

window.onerror = function (msg, url, lineNo, columnNo, error) {
  const errInfo = {
    body: {
      errormsg: msg,
      errorurl: url,
      lineNo,
      columnNo,
      'Error object': JSON.stringify(error.stack || {}),
    },
    logLevel: 'error',
  };
  sendNeloLog(errInfo);
};

axios
  .get('/p/contact/v2/domain/contacts/my')
  .then(
    ({ data }) => {
      const { contactNo: userId, domainId } = data;
      return Promise.all([
        axios.get(
          `/p/admin/api/authority/members/${userId}?domainId=${domainId}`,
        ),
        axios.get(`/p/admin/api/theme/domains/${domainId}`),
        axios.post(`/p/admin/api/domain/checkDns?domainId=${domainId}`),
      ]);
    },
    (err) => {
      if (err?.response?.status === 401) {
        window.location.replace(
          `${ServiceURL.AUTH}/login/login?accessUrl=${window.encodeURIComponent(
            window.location.href,
          )}`,
        );
        return Promise.reject();
      }
      throw new Error();
    },
  )
  .then(([memberResp, themeResp, domainResp]) => {
    const memberAuthResponse = memberResp?.data?.data;
    const themeResponse = themeResp?.data?.data;
    const domainStatusCode = domainResp?.data?.data?.domainStatus;
    const availableServices = memberAuthResponse.onServiceCodes;
    const hasCampaignCodeBanner = memberAuthResponse.onFunctionCodes.includes(
      'F044',
    );

    switch (domainStatusCode) {
      case 100: // 도메인 등록대기, 약관 미동의
        return window.location.replace(
          `${ServiceURL.AUTH}/view/noauth/waitDomain/alertAndGoAdmin`,
        );
      case 200: // 도메인 정상
        break;
      case 300: // 도메인 일시정지
        return window.location.replace(
          `${ServiceURL.AUTH}/view/noauth/stopDomain/alertAndGoAdmin`,
        );
    }

    const menuDisplay = {
      [MenuItemId.PERSONAL_INFO]: true,
      [MenuItemId.SECURITY]: true,
      [MenuItemId.NOTIFY]: true,
      [MenuItemId.BOARD]: availableServices.includes('home_web'),
      [MenuItemId.MESSAGE]: availableServices.includes('message_web'),
      [MenuItemId.MAIL]: availableServices.includes('mail_web'),
      [MenuItemId.CALENDAR]: availableServices.includes('calendar_web'),
      [MenuItemId.CONTACT]: availableServices.includes('contact_web'),
      [MenuItemId.DRIVE]: availableServices.includes('drive_web'),
    };

    const PC_PERMISSTION = availableServices?.includes('one_pc');

    const authorized = availableServices.includes('message_web');
    if (!authorized && window.location.pathname === `/settings/notify`) {
      window.location.replace(
        `${
          ServiceURL.AUTH
        }/view/noauth/noServiceAuth?requestUrl=${encodeURIComponent(
          window.location.href,
        )}`,
      );
      return;
    }

    ReactDom.render(
      <BrowserRouter>
        <PageProvider
          requires={[
            initI18n({ language, translations, fallbackTranslations }),
            injectIntlAndTimezonePolyfill(),
            getTimeZones(),
          ]}
          language={language}
          menuDisplay={menuDisplay}
          gnbBackgroundColor={themeResponse.webMainColor}
          gnbFontColor={themeResponse.webFontColor}
          hasCampaignCodeBanner={hasCampaignCodeBanner}
        >
          <AppErrorBoundary>
            <ToastProvider>
              <DialogProvider>
                <Switch>
                  <Route path="/settings" exact>
                    <MainScene availableServices={availableServices} />
                  </Route>
                  <Route path="/settings/notify" exact>
                    <SubScene pcPermission={PC_PERMISSTION} />
                  </Route>
                  <Route path="/settings/set_noti_time" exact>
                    <NotiTimeSetting />
                  </Route>
                  <Route path="*">
                    <NotFoundScene />
                  </Route>
                </Switch>
              </DialogProvider>
            </ToastProvider>
          </AppErrorBoundary>
        </PageProvider>
      </BrowserRouter>,
      document.getElementById('root'),
    );
  })
  .catch((err) => {
    ReactDom.render(
      <BrowserRouter>
        <PageProvider
          requires={[
            initI18n({ language, translations, fallbackTranslations }),
            injectIntlAndTimezonePolyfill(),
          ]}
          language={language}
        >
          {err && <UnknownScene />}
        </PageProvider>
      </BrowserRouter>,
      document.getElementById('root'),
    );
  });
